import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const Table = ({ children, className }) => (
  <table className={classnames(className, 'table')} data-testid="Table">
    {children}
  </table>
);

Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Table.defaultProps = {
  children: null,
  className: null,
};

export default Table;
